import { ThemeColors } from '@/ui/themes/themeSettings';

const colors: ThemeColors = {
    primaryColor: '#006296',
    primaryColorDark: '#005F7A',
    primaryColorLight: '#84C6EA',
    primaryColorLighter: '#E0F0F9',
    primaryColor2: '#012639',
    primaryColor3: '#003A5A',
    secondaryColor: '#EF483E',
    secondaryColorDark: '#D41F14',
    secondaryColorLight: '#F9B6B2',
    textColor: '#000000',
    textColorLight: '#60666E',
    textColor2: '#ffffff',
    textColor3: '#57666e',
    textColor4: '#878F9A',
    textColor5: '#B7BBC2',
    textColor6: '#012639',
    textActiveColor: '#008533',
    textColorNeutralBlack: '#1B1C1E',
    textColorSuccess: '#004F1E',
    textColorAlert: '#7B1A15',
    textColorWarning: '#A36D00',
    backgroundColor: '#ffffff',
    backgroundColor2: '#fefefe',
    backgroundColor3: '#fafafa',
    backgroundColor4: '#F3F3F4',
    backgroundColor5: '#DBDEE1',
    backgroundColor6: '#F1F2F2',
    backgroundColor7: '#878F9A',
    backgroundColor8: '#00A88E',
    backgroundColor9: '#7A1166',
    backgroundColor10: '#D9DDE2',
    backgroundColor11: '#B7BBC2',
    backgroundColor12: '#f5f5f5',
    backgroundColor13: '#E0F0F9',
    backgroundColor14: '#fdf7f6',
    backgroundColor15: '#fffbf5',
    backgroundColor16: '#F6FBF8',
    backgroundActiveColor: '#008533',
    borderColor: '#DBDEE1',
    borderColor1: '#D9DDE2',
    borderColor2: '#FFFFFF',
    borderColor3: '#000000',
    borderColor4: '#F1F2F2',
    borderColor5: '#878F9A',
    borderColor6: '#B7BBC2',
    borderColor7: '#012639',
    borderColorDark: '#60666E',
    boxShadowColor: 'rgb(0.0,0)',
    borderActiveColor: '#008533',
    borderColorAlert: '#f99d99',
    borderColorWarning: '#F5A200',
    borderColorCreateGroup: '#57666e',
    scrollbarColor: '#878F9A',
    errorColor: '#A40C2E',
    errorColor2: '#cd2c23',

    boxShadow1: '0 4px 8px 4px rgba(0, 0, 0, 0.2)',
};

export default colors;
